import React from "react";
import "./RestaurantOffer.scss";

export default function RestaurantOffer({ t }) {
  const RestaurantMenuOffer = [
    {
      title: t("menu_offer_title1"),
      items: [t("menu_offer1_item1"), t("menu_offer1_item2")],
    },
    {
      title: t("menu_offer_title2"),
      items: [
        t("menu_offer2_item1"),
        t("menu_offer2_item2"),
        t("menu_offer2_item3"),
        t("menu_offer2_item4"),
      ],
    },
    {
      title: t("menu_offer_title3"),
      items: [t("menu_offer3_item1")],
    },
    {
      title: t("menu_offer_title4"),
      items: [t("menu_offer4_item1")],
    },
    {
      title: t("menu_offer_title5"),
      items: [
        t("menu_offer5_item1"),
        t("menu_offer5_item2"),
        t("menu_offer5_item3"),
        t("menu_offer5_item4"),
        t("menu_offer5_item5"),
        t("menu_offer5_item6"),
      ],
    },
    {
      title: t("menu_offer_title6"),
      items: [
        t("menu_offer6_item1"),
        t("menu_offer6_item2"),
        t("menu_offer6_item3"),
      ],
    },
    {
      title: t("menu_offer_title7"),
      items: [
        t("menu_offer7_item1"),
        t("menu_offer7_item2"),
        t("menu_offer7_item3"),
        t("menu_offer7_item4"),
        t("menu_offer7_item5"),
        t("menu_offer7_item6"),
        t("menu_offer7_item7"),
      ],
    },
  ];
  return (
    <div className="restaurant-offer">
      <div className="restaurant-offer__content">
        <h1>{t("menu_title")}</h1>
        {RestaurantMenuOffer.map((menu) => (
          <div key={menu.title} className="restaurant-offer__item">
            <h2>{menu.title}:</h2>
            <div className="list">
              {menu.items.map((item) => (
                <p key={item}>- {item}</p>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
